import { render, staticRenderFns } from "./DependantDownloadsCard.vue?vue&type=template&id=679ebba9&scoped=true"
import script from "./DependantDownloadsCard.vue?vue&type=script&lang=js"
export * from "./DependantDownloadsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ebba9",
  null
  
)

export default component.exports